export default "__VITE_ASSET__Dsa$ov5e__"